import {all, fork} from "redux-saga/effects";
import appSaga from "./appSaga";
import authSaga from "./authSaga";
import UserSaga from "./UserSaga";
import TenantSag from "./TenantSag";
import MunicipalitySaga from "./MunicipalitySaga";
import AdoptionSaga from "./AdoptionSaga";
import ShedSaga from "./ShedSaga";
import DogSaga from "./DogSaga";
import TreatmentSaga from "./TreatmentSaga";
import BoxSaga from "./BoxSaga";
import MultimediaSaga from "./MultimediaSaga";
import UserSagaAdmin from "./UserSagaAdmin";


export default function* rootSaga(){
    yield all([fork(appSaga)])
    yield all([fork(authSaga)])
    yield all([fork(UserSaga)])
    yield all([fork(TenantSag)])
    yield all([fork(AdoptionSaga)])
    yield all([fork(MunicipalitySaga)])
    yield all([fork(ShedSaga)])
    yield all([fork(DogSaga)])
    yield all([fork(TreatmentSaga)])
    yield all([fork(BoxSaga)])
    yield all([fork(MultimediaSaga)])
    yield all([fork(UserSagaAdmin)])


}